
import ArrowCircleDown from "../../../assets/outline/ArrowCircleDown.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrowCircleDownIcon({ className, dataTestid = "ArrowCircleDownIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrowCircleDown data-testid={dataTestid} className={classes} {...rest} />
  );
}
